(function() {
  "use strict";

  function getValueByPath(object, path) {
    return path.split(".").reduce(function(result, key) {
      if (result && Object.prototype.hasOwnProperty.call(result, key)) {
        return result[key];
      }
      return null;
    }, object);
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function(resolve, reject) {
      var textarea = document.createElement("textarea");
      textarea.value = value;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand("copy");
        resolve();
      } catch (error) {
        reject(error);
      }

      document.body.removeChild(textarea);
    });
  }

  function initTutorial() {
    var root = document.querySelector("[data-tutorial-root]");
    var languageElement = document.getElementById("tutorial-language-data");
    var syncCurrentSection;
    var refreshSectionSubnavigation;

    if (!root || !languageElement) {
      return;
    }

    var translations;
    try {
      translations = JSON.parse(languageElement.textContent);
    } catch (error) {
      return;
    }

    function applyMetadata(data) {
      if (!data.meta) {
        return;
      }

      var title = data.meta.title;
      var description = data.meta.description;
      var selectors = {
        title: ['meta[property="og:title"]', 'meta[name="twitter:title"]'],
        description: ['meta[name="description"]', 'meta[property="og:description"]', 'meta[name="twitter:description"]']
      };

      if (title) {
        document.title = title;
        selectors.title.forEach(function(selector) {
          var element = document.querySelector(selector);
          if (element) {
            element.setAttribute("content", title);
          }
        });
      }

      if (description) {
        selectors.description.forEach(function(selector) {
          var element = document.querySelector(selector);
          if (element) {
            element.setAttribute("content", description);
          }
        });
      }
    }

    function applyLanguage(locale) {
      var data = translations[locale] || translations.nl;
      if (!data) {
        return;
      }

      root.querySelectorAll("[data-i18n]").forEach(function(element) {
        var value = getValueByPath(data, element.getAttribute("data-i18n"));
        if (typeof value === "string") {
          element.textContent = value;
        }
      });

      root.querySelectorAll("[data-i18n-html]").forEach(function(element) {
        var value = getValueByPath(data, element.getAttribute("data-i18n-html"));
        if (typeof value === "string") {
          element.innerHTML = value;
        }
      });

      root.querySelectorAll("[data-i18n-placeholder]").forEach(function(element) {
        var value = getValueByPath(data, element.getAttribute("data-i18n-placeholder"));
        if (typeof value === "string") {
          element.setAttribute("placeholder", value);
        }
      });

      root.querySelectorAll("[data-i18n-alt]").forEach(function(element) {
        var value = getValueByPath(data, element.getAttribute("data-i18n-alt"));
        if (typeof value === "string") {
          element.setAttribute("alt", value);
        }
      });

      root.querySelectorAll("[data-i18n-aria-label]").forEach(function(element) {
        var value = getValueByPath(data, element.getAttribute("data-i18n-aria-label"));
        if (typeof value === "string") {
          element.setAttribute("aria-label", value);
        }
      });

      root.querySelectorAll("[data-tutorial-discord]").forEach(function(link) {
        link.setAttribute("href", root.getAttribute("data-discord-url") || "https://discord.gg/tonigain");
      });

      root.setAttribute("data-tutorial-locale", locale);
      applyMetadata(data);

      if (typeof refreshSectionSubnavigation === "function") {
        window.requestAnimationFrame(refreshSectionSubnavigation);
      }

      if (typeof syncCurrentSection === "function") {
        window.requestAnimationFrame(syncCurrentSection);
      }

      var activeSearch = root.querySelector("[data-tutorial-search]");
      if (activeSearch && activeSearch.value) {
        activeSearch.dispatchEvent(new Event("input"));
      }
    }

    applyLanguage(document.documentElement.getAttribute("data-language") || "nl");
    document.addEventListener("tonigain:languagechange", function(event) {
      applyLanguage((event.detail && event.detail.locale) || "nl");
    });

    root.querySelectorAll("[data-copy-button]").forEach(function(button) {
      button.addEventListener("click", function() {
        var block = button.closest("[data-copy-block]");
        var source = block && block.querySelector("[data-copy-source]");
        var locale = root.getAttribute("data-tutorial-locale") || "nl";
        var labels = translations[locale] || translations.nl;
        if (!source) {
          return;
        }

        copyText(source.textContent.trim()).then(function() {
          button.textContent = labels.tutorial.copied;
          window.setTimeout(function() {
            button.textContent = labels.tutorial.copy;
          }, 1800);
        });
      });
    });

    root.querySelectorAll("[data-tutorial-helpful]").forEach(function(card) {
      var yesButton = card.querySelector("[data-helpful-yes]");
      var confirmation = card.querySelector("[data-helpful-confirmation]");

      if (!yesButton || !confirmation) {
        return;
      }

      yesButton.addEventListener("click", function() {
        confirmation.hidden = false;
        yesButton.disabled = true;
        yesButton.setAttribute("aria-pressed", "true");
      });
    });

    refreshSectionSubnavigation = (function() {
      var navigationLists = root.querySelectorAll(".tutorial-navigation__list");

      function makeSubLink(subnavigation, heading, targetId) {
        if (!heading || !heading.textContent.trim()) {
          return;
        }

        var item = document.createElement("li");
        var link = document.createElement("a");
        link.href = "#" + targetId;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        subnavigation.appendChild(item);
      }

      function buildSubnavigation() {
        navigationLists.forEach(function(list) {
          list.querySelectorAll("[data-tutorial-subnavigation]").forEach(function(subnavigation) {
            subnavigation.remove();
          });

          Array.prototype.slice.call(list.children).forEach(function(item) {
            var mainLink = item.querySelector("a[href^='#']");
            var targetId;
            var section;
            var subnavigation;
            var sectionHeading;

            if (!mainLink) {
              return;
            }

            targetId = mainLink.getAttribute("href").slice(1);
            section = document.getElementById(targetId);
            if (!section) {
              return;
            }

            subnavigation = document.createElement("ol");
            subnavigation.className = "tutorial-navigation__sublist";
            subnavigation.setAttribute("data-tutorial-subnavigation", "");
            sectionHeading = section.querySelector("h2");
            makeSubLink(subnavigation, sectionHeading, (sectionHeading && sectionHeading.id) || targetId);

            section.querySelectorAll("h3").forEach(function(heading, index) {
              if (!heading.id) {
                heading.id = targetId + "-subsection-" + (index + 1);
              }
              makeSubLink(subnavigation, heading, heading.id);
            });

            if (subnavigation.children.length) {
              item.appendChild(subnavigation);
            }
          });
        });
      }

      buildSubnavigation();
      return buildSubnavigation;
    })();

    syncCurrentSection = (function() {
      var sections = Array.prototype.slice.call(root.querySelectorAll(".tutorial-doc__section[id]"));
      var navigationLinks = Array.prototype.slice.call(root.querySelectorAll(".tutorial-navigation__list > li > a[href^='#']"));
      var currentLabels = root.querySelectorAll("[data-tutorial-current]");
      var frameRequested = false;

      if (!sections.length || !navigationLinks.length) {
        return function() {};
      }

      function getReadingLine() {
        var header = document.querySelector(".site-header");
        var headerHeight = header ? header.getBoundingClientRect().height : 0;
        return Math.max(headerHeight + 28, Math.min(window.innerHeight * 0.28, 260));
      }

      function getCurrentHeading(section, readingLine) {
        var headings = Array.prototype.slice.call(section.querySelectorAll("h2[id], h3[id]"));
        var currentHeading = headings[0] || null;

        headings.forEach(function(heading) {
          if (heading.getBoundingClientRect().top <= readingLine) {
            currentHeading = heading;
          }
        });

        return currentHeading;
      }

      function keepMainLinkVisible(link) {
        var navigation = link && link.closest(".tutorial-navigation");
        var sidebar = navigation && navigation.closest(".tutorial-sidebar");
        var navigationBounds;
        var linkBounds;

        if (!navigation || !sidebar) {
          return;
        }

        navigationBounds = navigation.getBoundingClientRect();
        linkBounds = link.getBoundingClientRect();
        if (linkBounds.top < navigationBounds.top || linkBounds.bottom > navigationBounds.bottom) {
          navigation.scrollBy({
            top: linkBounds.top - navigationBounds.top - (navigation.clientHeight / 2) + (linkBounds.height / 2),
            behavior: "smooth"
          });
        }
      }

      function setCurrentSection(section, readingLine) {
        var id;
        var currentLabel = "";
        var currentMainLink = null;
        var currentHeading;
        var currentHeadingLabel = "";

        if (!section) {
          return;
        }

        id = section.id;
        navigationLinks.forEach(function(link) {
          var isCurrent = link.getAttribute("href") === "#" + id;
          link.classList.toggle("is-current", isCurrent);
          if (link.parentElement) {
            link.parentElement.classList.toggle("is-current-item", isCurrent);
          }

          if (isCurrent) {
            link.setAttribute("aria-current", "location");
            currentMainLink = link;
            if (!currentLabel) {
              currentLabel = link.textContent.trim();
            }
          } else {
            link.removeAttribute("aria-current");
          }
        });

        currentHeading = getCurrentHeading(section, readingLine);
        root.querySelectorAll(".tutorial-navigation__sublist a[href^='#']").forEach(function(link) {
          var isCurrentSubsection = currentHeading && link.getAttribute("href") === "#" + currentHeading.id;
          link.classList.toggle("is-current-subsection", isCurrentSubsection);
          if (isCurrentSubsection) {
            link.setAttribute("aria-current", "location");
            currentHeadingLabel = link.textContent.trim();
          } else {
            link.removeAttribute("aria-current");
          }
        });

        currentLabels.forEach(function(label) {
          label.textContent = currentHeadingLabel ? currentLabel + " > " + currentHeadingLabel : currentLabel;
        });

        keepMainLinkVisible(currentMainLink);
      }

      function findCurrentSection() {
        var readingLine = getReadingLine();
        var current = null;

        sections.forEach(function(section) {
          if (window.getComputedStyle(section).display === "none") {
            return;
          }

          if (section.getBoundingClientRect().top <= readingLine) {
            current = section;
          }
        });

        if (!current) {
          current = sections.find(function(section) {
            return window.getComputedStyle(section).display !== "none";
          });
        }

        setCurrentSection(current, readingLine);
      }

      function scheduleCurrentSection() {
        if (frameRequested) {
          return;
        }

        frameRequested = true;
        window.requestAnimationFrame(function() {
          frameRequested = false;
          findCurrentSection();
        });
      }

      window.addEventListener("scroll", scheduleCurrentSection, { passive: true });
      window.addEventListener("resize", scheduleCurrentSection);
      scheduleCurrentSection();

      return scheduleCurrentSection;
    })();

    var search = root.querySelector("[data-tutorial-search]");
    var searchResult = root.querySelector("[data-search-result]");
    var searchItems = root.querySelectorAll("[data-search-item]");
    if (search) {
      search.addEventListener("input", function() {
        var query = search.value.trim().toLocaleLowerCase();
        var visibleCount = 0;
        var matchingItems = [];
        var locale = root.getAttribute("data-tutorial-locale") || "nl";
        var labels = translations[locale] || translations.nl;

        searchItems.forEach(function(item) {
          var searchableText = (item.textContent + " " + (item.getAttribute("data-search-keywords") || "")).toLocaleLowerCase();
          var isMatch = !query || searchableText.indexOf(query) !== -1;
          item.classList.toggle("is-search-hidden", !isMatch);
          if (isMatch) {
            visibleCount += 1;
            matchingItems.push(item);
          }
        });

        syncCurrentSection();

        if (!searchResult) {
          return;
        }

        searchResult.innerHTML = "";
        searchResult.classList.remove("is-visible");
        if (!query) {
          return;
        }

        searchResult.classList.add("is-visible");
        if (visibleCount) {
          var summary = document.createElement("span");
          var resultList = document.createElement("ul");

          summary.className = "tutorial-search__result-summary";
          summary.textContent = labels.tutorial.search_results.replace("{count}", visibleCount);
          resultList.className = "tutorial-search__result-list";

          matchingItems.forEach(function(item) {
            var itemHeading = item.querySelector("h2");
            var resultItem = document.createElement("li");
            var resultLink = document.createElement("a");

            if (!itemHeading || !item.id) {
              return;
            }

            resultLink.className = "tutorial-search__result-link";
            resultLink.href = "#" + item.id;
            resultLink.textContent = itemHeading.textContent.trim();
            resultLink.addEventListener("click", function() {
              search.value = "";
              search.dispatchEvent(new Event("input"));
            });
            resultItem.appendChild(resultLink);
            resultList.appendChild(resultItem);
          });

          searchResult.appendChild(summary);
          searchResult.appendChild(resultList);
        } else {
          searchResult.textContent = labels.tutorial.search_empty;
        }
      });
    }

    root.addEventListener("click", function(event) {
      var link = event.target.closest(".tutorial-navigation a[href^='#']");
      var mobileNavigation;

      if (!link || !root.contains(link)) {
        return;
      }

      mobileNavigation = root.querySelector(".tutorial-mobile-navigation");
      if (mobileNavigation) {
        mobileNavigation.removeAttribute("open");
      }

      window.setTimeout(syncCurrentSection, 50);
      window.setTimeout(syncCurrentSection, 300);
    });

    var dialog = root.querySelector("[data-tutorial-lightbox]");
    var dialogImage = dialog && dialog.querySelector("[data-lightbox-image]");
    var dialogCaption = dialog && dialog.querySelector("[data-lightbox-caption]");
    if (dialog && dialogImage) {
      root.querySelectorAll("[data-lightbox-trigger]").forEach(function(trigger) {
        trigger.addEventListener("click", function() {
          var image = trigger.querySelector("img");
          if (!image) {
            return;
          }
          dialogImage.src = trigger.getAttribute("data-full-src") || image.currentSrc || image.src;
          dialogImage.alt = image.alt;
          if (dialogCaption) {
            dialogCaption.textContent = trigger.getAttribute("data-lightbox-caption") || image.alt;
          }
          if (typeof dialog.showModal === "function") {
            dialog.showModal();
          } else {
            dialog.setAttribute("open", "");
          }
        });
      });

      dialog.querySelectorAll("[data-lightbox-close]").forEach(function(button) {
        button.addEventListener("click", function() {
          if (typeof dialog.close === "function") {
            dialog.close();
          } else {
            dialog.removeAttribute("open");
          }
        });
      });

      dialog.addEventListener("click", function(event) {
        if (event.target === dialog) {
          if (typeof dialog.close === "function") {
            dialog.close();
          } else {
            dialog.removeAttribute("open");
          }
        }
      });
    }
  }

  document.addEventListener("DOMContentLoaded", initTutorial);
})();
